
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.92 9.79"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"V4_copy","data-name":"V4 copy"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M7.24 4.89L5.28.17c-.07-.23-.57-.23-.64 0L2.68 4.89c-.05.18-.41.24-.58.09L.58 3.36C.39 3.19 0 3.28 0 3.49l.78 4.49c0 .12.15.22.32.22h7.57c.18 0 .32-.1.32-.22l.93-4.49c0-.21-.4-.3-.58-.13L7.82 4.98c-.17.15-.52.1-.58-.09z"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":".8","y":"8.9","width":"8.13","height":".72","rx":".36","ry":".36","transform":"rotate(-2.72 4.84 9.176)"}})])])
          )
        }
      }
    